import { ApplicationStatus } from "../interfaces/enums";
import { ApplicationWithId } from "../interfaces/IApplications";
import { approveApplicationIfRegistrationOpen, findApplicationSnapshot } from "../utils/firestore";
import { useApplicationsContext } from "../contexts/ApplicationsContext";
import { useEffect, useState } from "react";
import { useUserContext } from "../contexts/UserContext";

export const useApplication = (applicationId: string) => {
  const { handleApplicationUpdate, refreshApplication } = useApplicationsContext();
  const { user } = useUserContext();
  const [application, setApplication] = useState<ApplicationWithId | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!applicationId || !user?.id) {
      setIsLoading(false);
      return;
    }

    // STARA IMPLEMENTACJA - wykomentowana dla łatwego przywrócenia
    // const { applications } = useApplicationsContext();
    // const fetchData = async () => {
    //   setIsLoading(true);
    //   try {
    //     if (applications && applicationId) {
    //       // Pobieramy jedną aplikację
    //       const application = applications.find((application) => application.id === applicationId);
    //       setApplication(application ? application : null);
    //     }
    //   } catch (error) {
    //     console.error("Błąd podczas pobierania aplikacji:", error);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };
    // fetchData();

    // NOWA IMPLEMENTACJA - onSnapshot
    setIsLoading(true);
    const unsubscribe = findApplicationSnapshot(user.id, applicationId, (applicationData) => {
      setApplication(applicationData);
      setIsLoading(false);
    });

    // Cleanup - odsubskrybowanie przy unmount lub zmianie applicationId/userId
    return () => {
      unsubscribe();
    };
  }, [applicationId, user?.id]);

  const updateApplicationStatus = async (
    status: ApplicationStatus,
  ): Promise<{ success: boolean; error?: string }> => {
    if (application) {
      // Wariant 1: transakcja przy próbie wysłania
      if (status === ApplicationStatus.SENT) {
        const result = await approveApplicationIfRegistrationOpen(
          application.userId,
          application.id,
          application.contestId,
        );
        if (result.success) {
          // Odśwież lokalny stan po udanej transakcji
          await refreshApplication(application.userId, application.id);
        }
        return result;
      }

      // Pozostałe statusy – zwykła ścieżka aktualizacji
      const result = await handleApplicationUpdate(application.id!, {
        status,
      });
      if (result.success) {
        await refreshApplication(application.userId, application.id);
        return { success: true };
      }
      return { success: false, error: result.error };
    }
    return { success: false, error: "Brak zgłoszenia" };
  };

  return {
    application,
    isLoading,
    handleApplicationUpdate,
    refreshApplication,
    updateApplicationStatus,
  };
};
